import React from 'react';
import PropTypes from 'prop-types';
import ScrollableWiresList from './scrollable-wires-list';

export default function AllWires({ contributorId, contributorName, isScrollable }) {
  return (
    <ScrollableWiresList
      contributorId={contributorId}
      contributorName={contributorName}
      isScrollable={isScrollable}
      type="all"
    />
  );
}

AllWires.propTypes = {
  contributorId: PropTypes.number.isRequired,
  contributorName: PropTypes.string.isRequired,
  isScrollable: PropTypes.bool,
};

AllWires.defaultProps = {
  isScrollable: false,
};
